module.exports = "/fonts/gh-icons.ttf?d4edc01502adc4ea2e103ec846cfeffd";